const FILTER_TYPE = {
	BRAND: 'brand',
	PRICE: 'price',
	TERM: 'Term',
	INTERVAL: 'Interval',
	PRICE_RANGE: 'pricerange',
	RANGE: 'Range',
	FILTER_RADIO: 'Radio',
	FILTER_TYPE_MOBILE: 'Mobile',
	FILTER_TYPE_DESKTOP: 'Desktop',
	FILTER_TYPE_QUICK: 'Quick',
	QUICK_FILTER_TEXT: 'Quick-Filters',
	ADVANCE_FILTER_TEXT: 'Advanced-Filters'
};

module.exports = FILTER_TYPE;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/filters/advance-filter/filter-type-enum.js
 **/